/* Общие куски экрана клиентов: каналы согласий, значки согласий, теги клиента, мини-показатель. */
import type { ReactNode } from "react";
import type { Consents, Customer, CustomerStats } from "@okno/shared";
import { Icon } from "../../ui/Icon";

export type ConsentKey = keyof Consents;

export const CHANNELS: [ConsentKey, string][] = [
  ["sms", "SMS"],
  ["wa", "WhatsApp"],
  ["push", "Push"],
  ["geo", "Геолокация"],
];

/** Короткие значки согласий в строке таблицы. */
export function ConsentIcons({ consents }: { consents: Consents }) {
  return (
    <div className="consents">
      {CHANNELS.map(([k, l]) => (
        <span key={k} className={"consent" + (consents[k] ? " is-on" : "")} title={l + (consents[k] ? ": согласие есть" : ": нет согласия")}>
          {l.slice(0, k === "geo" ? 3 : 2)}
        </span>
      ))}
    </div>
  );
}

/** Теги клиента: постоянный, пора вернуть, неявки, смарт-визиты. */
export function ClientTags({ customer, stats }: { customer: Customer; stats: CustomerStats }) {
  const out: ReactNode[] = [];
  if (stats.visits >= 5)
    out.push(
      <span key="reg" className="chip">
        Постоянный
      </span>,
    );
  if (stats.daysSince != null && stats.daysSince > customer.interval)
    out.push(
      <span key="lapsed" className="chip chip-signal">
        Пора вернуть
      </span>,
    );
  if (stats.noShows)
    out.push(
      <span key="ns" className="chip chip-minus">
        Неявки: {stats.noShows}
      </span>,
    );
  if (stats.smart)
    out.push(
      <span key="smart" className="chip">
        <Icon name="zap" size={12} />
        Смарт: {stats.smart}
      </span>,
    );
  return out.length ? <div className="row">{out}</div> : null;
}

export function Mini({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="mini">
      <span className="kpi-label">{label}</span>
      <strong className="num">{value}</strong>
    </div>
  );
}
